
































import { Component, Vue } from 'vue-property-decorator'

import { Action, State } from 'vuex-class'

import { ConfirmLeaveModal, OrderFiltersForm } from '@/components'

import { MobileLayout } from '@/layouts/components'

import { ModalState, OrderFilters, OrderPageQuery, OrderStatus } from '@/models'

import { RootState } from '@/store/state'

import { isSetsEqual, normalizeDate } from '@/utils'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    OrderFiltersForm
  }
})
export default class ChangeOrderFilters extends Vue {
  confirmLeaveState = new ModalState()

  defaultFilters: OrderFilters = {
    status: [
      OrderStatus.AUTHORIZED,
      OrderStatus.STARTED
    ]
  }

  data: OrderFilters | null = null
  isValid = false

  get hasChanges () {
    return this.data !== null && !this.compareFilters(this.data, this.query)
  }

  get isClear () {
    return this.data !== null && this.compareFilters(this.data, this.defaultFilters)
  }

  @State((state: RootState) => state.ordering.orders.query)
  readonly query!: OrderPageQuery

  @Action('ordering/changeOrderFilter')
  changeFilters!: (params: { filters: OrderFilters; isDefaultFilters: boolean }) => Promise<void>

  @Action('ordering/loadOrderPage')
  loadOrderPage!: () => Promise<void>

  async reload () {
    try {
      await this.loadOrderPage()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async clearFilters () {
    await this.changeFilters({
      filters: this.defaultFilters,
      isDefaultFilters: true
    })

    this.goBack()
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    await this.changeFilters({
      filters: {
        from: normalizeDate(this.data.from ?? '') ?? undefined,
        until: normalizeDate(this.data.until ?? '') ?? undefined,
        status: this.data.status
      },
      isDefaultFilters: this.isClear
    })
    await this.reload()
    this.goBack()
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.goBack()
    }
  }

  goBack () {
    this.$router.back()
  }

  compareFilters (a: OrderFilters, b: OrderFilters): boolean {
    return (
      (a.from === b.from || (!a.from && !b.from)) &&
      (a.until === b.until || (!a.until && !b.until)) &&
      isSetsEqual(new Set(a.status), new Set(b.status))
    )
  }
}
